import { stationsActions } from '../reducer';

import { StationsState } from '../../types';

export const updateFilteredStationsLoadingStatus = (
  loadingStatus?: StationsState['filteredStations']['loadingStatus']
) => stationsActions.setFilteredStationsLoadingStatus(loadingStatus);
